import React from 'react';

const Intro = () => {
  return (
    <section id="intro" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-pink-800 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="./p3.png" 
          alt="Hair salon interior" 
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/60 via-purple-800/40 to-pink-800/60"></div>
      </div>
      
      <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="animate-fade-in-up">
          <p className="text-lg md:text-xl mb-6 text-purple-200 font-light tracking-wide">Welcome to</p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
            <span className="bg-gradient-to-r from-white via-purple-100 to-pink-100 bg-clip-text text-transparent">
              Khair Spa
            </span>
            <br />
            <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-purple-100">
              Beauty & Hair Excellence
            </span>
          </h1>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center items-center animate-fade-in-up animation-delay-300">
          <a 
            href="#about" 
            className="group bg-white text-purple-900 px-8 py-4 rounded-full hover:bg-purple-50 transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 min-w-[200px]"
          >
            <span className="group-hover:mr-2 transition-all duration-300">Our Services</span>
            <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">→</span>
          </a>
          <a 
            href="#footer" 
            className="group border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-purple-900 transition-all duration-300 font-semibold text-lg backdrop-blur-sm hover:backdrop-blur-none transform hover:scale-105 min-w-[200px]"
          >
            <span className="group-hover:mr-2 transition-all duration-300">Book Appointment</span>
            <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">✓</span>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#about" className="text-white/80 hover:text-white transition-colors p-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" className="drop-shadow-lg">
            <path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"></path>
          </svg>
        </a>
      </div>

      {/* Floating elements for visual appeal */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-32 right-16 w-32 h-32 bg-pink-300/20 rounded-full blur-2xl animate-pulse animation-delay-1000"></div>
      <div className="absolute top-1/3 right-8 w-16 h-16 bg-purple-300/20 rounded-full blur-xl animate-pulse animation-delay-500"></div>
    </section>
  );
};

export default Intro;